
import { defineComponent, ref, toRefs } from 'vue';
import { VueperSlide, VueperSlides } from 'vueperslides';
import Testimonial from '@/components/testimonial/Testimonial.vue';
import { debounce } from 'lodash-es';

export default defineComponent({
  name: 'Testimonials',
  props: {
    title: String,
    testimonials: Array,
  },
  components: {
    VueperSlides,
    VueperSlide,
    Testimonial,
  },
  setup(props, { emit }) {
    const refProps = toRefs(props);

    // The following is some code to ensure click events are not sent if they are directly preceded
    // by a slide event.
    // This is to ensure dragging slides does not cause you to open a modal or something
    const isClickBlocked = ref(false);
    const resetClickBlock = debounce(() => {
      isClickBlocked.value = false;
    }, 300);

    const blockClicks = () => {
      isClickBlocked.value = true;
      resetClickBlock();
    };
    const onSlideClick = (testimonial) => {
      if (isClickBlocked.value) return;
      emit('testimonial', testimonial);
    };

    return {
      ...refProps,
      blockClicks,
      onSlideClick,
    };
  },
});
